export default __webpack_public_path__ + "static/media/step3.decb5ef6.svg";